import React from "react";
import { connect } from "react-redux";
import AccessGroupUserTable from "./components/AccessGroupUserTable";

const AccessGroupUsers = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<AccessGroupUserTable/>

	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
	filters: state.accessGroupUser.accessGroupUserList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessGroupUsers);